import React from 'react';

import {SearchDatesDetailsInputField} from '../SearchDatesDetailsInputField';
import {SearchDestinationDetailsInputField} from '../SearchDestinationDetailsInputField';
import {SearchGuestsDetailsInputField} from '../SearchGuestsDetailsInputField';
import {SearchSubmitDetailsButtonField} from '../SearchSubmitDetailsButtonField';

import {useComponent} from './hooks';

import './SearchDetailsFields.less';

import '../SearchDetailsField/SearchDetailsField.less';
import '../SearchDetailsInputField/SearchDetailsInputField.less';
import '../SearchDetailsButtonField/SearchDetailsButtonField.less';

function SearchDetailsFields() {
    const {
        className,
        showGuestsDetailsInputField,
        showSubmitDetailsButtonField
    } = useComponent();

    return (
        <div className={className}>
            <SearchDestinationDetailsInputField/>
            <SearchDatesDetailsInputField/>
            {showGuestsDetailsInputField && (
                <SearchGuestsDetailsInputField/>
            )}
            {showSubmitDetailsButtonField && (
                <SearchSubmitDetailsButtonField/>
            )}
        </div>
    );
}

SearchDetailsFields.whyDidYouRender = true;

export {SearchDetailsFields};
